const $ = window.jQuery;
const $window = window.$window || $(window);
import Modals from "@marcomessa/tailwind-modal";

const contactModal = {
    init() {
        const modals = new Modals();
        modals.init();
        $('.menu li').click(function () {
            $('.modal__button').click();
        });
    },
};

export default contactModal;
